import { useTranslation } from 'react-i18next'
import { formatCount, formatPercent, formatShortDate, headlineParts } from './coverageFormat'
import { COVERAGE_SLICES } from '../../services/proofVideoCoverageService'
import { COVERAGE_I18N } from './i18nKeys'

const numeric = 'px-3 py-2 text-right tabular-nums'

export const CoverageTable = ({ coverage }) => {
  const { t, i18n } = useTranslation()
  const { packed, slices, from, to } = coverage
  const { language } = i18n
  const headline = headlineParts(coverage, t, language)

  return (
    <div className="flex flex-col gap-5">
      <div>
        <p className="text-sm font-semibold text-gray-900">{t(`${COVERAGE_I18N}.headline.label`)}</p>
        <p className="mt-1 flex items-baseline gap-2">
          <span className="text-4xl font-bold tabular-nums text-gray-900">{headline.rate}</span>
          <span className="text-sm text-gray-700">{headline.ofPacked}</span>
        </p>
        <p className="mt-1 text-sm text-gray-600">{t(`${COVERAGE_I18N}.headline.description`)}</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <caption className="pb-2 text-left font-semibold text-gray-900">
            {t(`${COVERAGE_I18N}.table.caption`, { from: formatShortDate(from, language), to: formatShortDate(to, language) })}
          </caption>
          <thead>
            <tr className="border-b border-gray-300 text-gray-700">
              <th scope="col" className="px-3 py-2 text-left font-semibold">
                {t(`${COVERAGE_I18N}.table.situation`)}
              </th>
              <th scope="col" className={`${numeric} font-semibold`}>
                {t(`${COVERAGE_I18N}.table.orders`)}
              </th>
              <th scope="col" className={`${numeric} font-semibold`}>
                {t(`${COVERAGE_I18N}.table.share`)}
              </th>
            </tr>
          </thead>
          <tbody>
            {COVERAGE_SLICES.map(slice => (
              <tr key={slice} className="border-b border-gray-200 align-top">
                <th scope="row" className="px-3 py-2 text-left font-medium text-gray-900">
                  {t(`${COVERAGE_I18N}.slices.${slice}.label`)}
                  <span className="block font-normal text-gray-600">{t(`${COVERAGE_I18N}.slices.${slice}.description`)}</span>
                </th>
                <td className={numeric}>{formatCount(slices[slice], language)}</td>
                <td className={numeric}>{formatPercent(slices[slice] / packed, language)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="font-semibold text-gray-900">
              <th scope="row" className="px-3 py-2 text-left">
                {t(`${COVERAGE_I18N}.table.total`)}
              </th>
              <td className={numeric}>{formatCount(packed, language)}</td>
              <td className={numeric} />
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}
